/**
 * Theme-owned CTA label; click is forwarded to the hidden Klaviyo embed button
 * so we never mutate Klaviyo markup (which was hiding the embed after open).
 * Visible only when Klaviyo has injected a button (respects their targeting).
 */
(function () {
  function findKlaviyoButton(wrapper) {
    return wrapper.querySelector(
      '.product-card-signup-cta__embed .klaviyo-form-button, .product-card-signup-cta__embed button[type="button"]'
    );
  }

  function syncVisibility(wrapper) {
    var trigger = wrapper.querySelector('.product-card-signup-cta__trigger');
    if (!trigger) return;

    // Once shown, keep it — Klaviyo may tear down its button after opening the popup
    if (wrapper.dataset.signupReady === 'true') return;

    if (findKlaviyoButton(wrapper)) {
      trigger.hidden = false;
      wrapper.dataset.signupReady = 'true';
      wrapper.classList.add('is-ready');
    }
  }

  function syncAll(root) {
    (root || document).querySelectorAll('.product-card-signup-cta').forEach(syncVisibility);
  }

  function openViaEmbed(wrapper) {
    var button = findKlaviyoButton(wrapper);
    if (button) {
      button.click();
      return true;
    }
    return false;
  }

  function openViaApi(wrapper) {
    var formId = wrapper.getAttribute('data-klaviyo-form-id');
    if (!formId) return;

    window._klOnsite = window._klOnsite || [];
    if (typeof window._klOnsite.openForm === 'function') {
      window._klOnsite.openForm([formId]);
      return;
    }
    window._klOnsite.push(['openForm', formId]);
  }

  function triggerSignup(wrapper) {
    if (openViaEmbed(wrapper)) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (openViaEmbed(wrapper) || attempts >= 10) {
        clearInterval(timer);
        if (attempts >= 10 && !findKlaviyoButton(wrapper)) {
          openViaApi(wrapper);
        }
      }
    }, 100);
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.product-card-signup-cta__trigger');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      var wrapper = trigger.closest('.product-card-signup-cta');
      if (wrapper) triggerSignup(wrapper);
    },
    true
  );

  function init() {
    syncAll(document);

    var observer = new MutationObserver(function () {
      syncAll(document);
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
